export default __webpack_public_path__ + "static/media/13-25_Cs.56f1899c.svg";